/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  magenta_10: '#f7dae3',
  magenta_20: '#f7bacd',
  magenta_30: '#f590b0',
  magenta_40: '#f06591',
  magenta_50: '#e63e73',
  magenta_60: '#d92762',
  magenta_70: '#c91451',
  magenta_80: '#b30b43',
  magenta_90: '#a1083b',
  magenta_100: '#8d0633',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/magenta.js